import React from 'react'
import { MyCareersPage } from '../../pages/CareersPage/MyCareersPage';
import { SchedulePage } from '../../pages/SchedulePage/SchedulePage';
import { OpinionsPage } from '../../pages/OpinionsPage/OpinionsPage';
import { TutorsPage } from '../../pages/TutorsPage/TutorsPage';

export const HomeRouter = ({path,toggleHowWorks,toggleAddCareer,toggleDeleteCareer,toggleAddOpinion,toggleAddTutor,myTutor}) => {

    switch(path){
        case '/home':
            return <MyCareersPage toggleDeleteCareer={toggleDeleteCareer} toggleAddCareer={toggleAddCareer} toggleHowWorks={toggleHowWorks}/>

        case '/schedule':
            return <SchedulePage/>

        case '/opinions':
            return <OpinionsPage toggleAddOpinion={toggleAddOpinion}/>

        case '/tutors':
            return <TutorsPage toggleAddTutor={toggleAddTutor}/>

        default:
            break;
    }

}
